module.exports = __webpack_public_path__ + "img/solution2-2.2fd4b038.png";